export var InstanceVersionUpdatePolicy;
(function (InstanceVersionUpdatePolicy) {
    InstanceVersionUpdatePolicy["Manual"] = "manual";
    InstanceVersionUpdatePolicy["Stable"] = "stable";
    InstanceVersionUpdatePolicy["Beta"] = "beta";
})(InstanceVersionUpdatePolicy || (InstanceVersionUpdatePolicy = {}));
export var ModuleInstanceType;
(function (ModuleInstanceType) {
    ModuleInstanceType["Connection"] = "connection";
    ModuleInstanceType["Surface"] = "surface";
})(ModuleInstanceType || (ModuleInstanceType = {}));
//# sourceMappingURL=Instance.js.map